import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MobileDelegateService } from '../../../core/services/mobile-delegate.service';
import { OtpModalBoardMobileComponent } from '../otp-modal-board-mobile/otp-modal-board-mobile.component';
import { ModalOptionsConfig, ModalService } from '../../../lean-shared/components/nz-modal-service/modal.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { DelegateType } from '../../../shared/models/utility.model';


@Component({
	selector: 'app-ussd-board',
	templateUrl: './ussd-board.component.html',
	styleUrls: ['./ussd-board.component.scss']
})
export class UssdBoardComponent implements OnInit {
	@Input() ussdCode: boolean;
	@Input() isBvnUssd: any;
	@Input() version = 0;
	@Input() countdown: any;
	@Input() isMobile: boolean;
	readonly BVN_USSD = '*565*0#';
	runningModal: NzModalRef;
	@Input() ussd: string;
	@Input() showResendButtonCountDown: boolean = false
	@Input() canUseNewResendOtpUi: boolean = true
	@Output() emitOtpResponse = new EventEmitter ();

	constructor(private delegateService: MobileDelegateService, private modalService: ModalService) {

	}

	lunchDialer(dialCode) {
		this.delegateService.setDelegateData(DelegateType.launchDialer, dialCode)
		.then(() => {
		})
		.catch(error => {
			console.log('Error from lunchDialer delegate ', error);
		});
	}

	ngOnInit(): void {
	}

	launchOtpModalBoard(){
		this.openMobileOtpModalBoard();
	}

	openMobileOtpModalBoard(){
		if (!this.isMobile){
			return;
		}
		const config = this.createModalConfig();
		this.runningModal = this.modalService.createModal(OtpModalBoardMobileComponent, config);
	}

	private createModalConfig() {
		const config = new ModalOptionsConfig();
		config.nzMaskClosable = true;
		config.className = 'moniepoint-dialog';
		const ussd = this.ussd;
		const countdown = this.countdown;
		const canUseNewResendOtpUi = this.canUseNewResendOtpUi;
		config.nzComponentParams.data = {ussd, countdown, canUseNewResendOtpUi};
		config.nzComponentParams.callback = (result) => {
			this.handleCloseModal(result);
		};
		return config;
	}

	handleCloseModal(result){
		this.emitOtpResponse.emit(result);
	}

	formatTime = (t) => {
		return t < 10 ? '0' + t : t;
	}

}
